import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined'
import InfoIcon from '@mui/icons-material/Info'
import LinkOffIcon from '@mui/icons-material/LinkOff'
import { Box, IconButton, Tooltip } from '@mui/material'
import VoucherApi from "api/voucher/voucher.api"
import ModalCustom from 'component/ModalCustom/ModalCustom'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { colors } from 'constants/theme'
import AlertModal from 'new-components/modal/alert-modal'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { dateToView } from 'utils/date.utils'

type FormViewVoucherProps = {
    onClose: (reload: boolean) => void
    dataVoucher: any
}

const FormViewVoucher = (props: FormViewVoucherProps) => {
    const { t } = useTranslation()

    const [page, setPage] = useState<number>(1)
    const [pageLimit, setPageLimit] = useState<number>(5)
    const [rowCount, setRowCount] = useState<number>(0)
    const [sortBy, setSortBy] = useState('voucherId')
    const [sortType, setSortType] = useState('DESC')

    const [copy, setCopy] = useState(0)

    const [idUnlink, setIdUnlink] = useState(0)
    const [voucherUnlink, setVoucherUnlink] = useState<number[]>([])
    const [isReload, setIsReload] = useState<boolean>(false)

    const [isOpenSnack, setIsOpenSnack] = useState(false)


    const handleUnlinkVoucher = async (id: number) => {
        await VoucherApi.deleteVoucherList([id], 'UNLINK').then(() => {
            setIsOpenSnack(true)
            setVoucherUnlink((prev) => [...prev, id])
            setIsReload(true)
            setIdUnlink(0)
        })
    }

    const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
        setSortType(sortTypeVal)
        setSortBy(sortByVal)
    }

    const handleChangePage = (val: number) => setPage(val)

    const handleChangeRowsPerPage = (limit: number) => setPageLimit(limit)

    const headCells = [
        { id: 'no', disablePadding: false, label: t('TABLE.NO'), width: '50px', align: 'center', },
        { id: 'code', disablePadding: false, label: t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_CODE_'), align: 'left', class: 'text-nowrap ' },
        { id: 'codeList', disablePadding: false, label: t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_CODE_LOT'), width: '100px', align: 'center', class: 'text-nowrap ' },
        { id: 'endDate', disablePadding: false, label: t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_DATEEND'), width: '120px', align: 'center', class: 'text-nowrap ' },
        { id: 'action', disablePadding: false, label: t('Action'), width: '120px', align: 'center', class: 'text-nowrap ' },
    ]

    const renderData = (objData: any, index: number,) => {
        const newIndex = page * pageLimit - pageLimit + index + 1
        const { voucherListId, voucherCode, endDate, lotNumber } = objData

        const formatNumber = (num: number) => {
            if (!num) {
                return num
            }
            return num.toString().padStart(4, '0');
        };

        const commonColumns = [
            { option: 'TEXT', align: 'center', label: newIndex },
            {
                option: 'COMPONENT', class: 'text-nowrap', component: (
                    <Box display={'flex'} alignItems={'center'} gap={'8px'} position="relative">
                        {voucherCode}
                        <Box onClick={() => handleCopyClick(voucherCode, newIndex)} sx={{ cursor: 'pointer', 'svg': { fill: '#808080' } }}>
                            <FileCopyOutlinedIcon />
                            <Box>
                                {copy === newIndex &&
                                    <Box position="absolute" padding="10px" bgcolor="#5A5A5A" color="#FFFFFF" borderRadius="2px" top="-40px" fontSize="14px" fontWeight={400}>Copied</Box>
                                }
                            </Box>
                        </Box>
                    </Box>
                )
            },
            { option: 'TEXT', class: 'text-nowrap ', align: 'center', label: formatNumber(lotNumber) },
            { option: 'TEXT', align: 'center', label: dateToView(endDate) },
            {
                option: "COMPONENT", component: (
                    <Box textAlign={'center'}>
                        <IconButton sx={{ border: `1px solid ${colors.themeThirdColor}`, borderRadius: '4px' }} onClick={() => setIdUnlink(voucherListId)}>
                            <LinkOffIcon sx={{ color: colors.themeThirdColor }} />
                        </IconButton>
                    </Box>
                )
            }
        ]

        const objRenderData = {
            key: voucherListId,
            id: voucherListId,
            obj: objData,
            columns: commonColumns
        }

        return <TableRowCommon {...objRenderData} />
    }

    const renderVoucher = () => {
        const startIndex = (page - 1) * pageLimit
        const dataVoucher = props.dataVoucher?.voucherDetails?.filter((item: any) => !voucherUnlink.includes(item?.voucherListId))
        return dataVoucher?.slice(startIndex, startIndex + pageLimit)
    }

    useEffect(() => {
        setRowCount(props.dataVoucher?.voucherDetails?.length || 0)
    }, [props.dataVoucher?.voucherDetails])

    const handleCopyClick = (text: string, index: number) => {
        setCopy(index);
        navigator?.clipboard?.writeText(text)
        setTimeout(() => {
            setCopy(0);
        }, 2000);
    };

    return (
        <>
            <AlertModal
                isOpen={!!idUnlink}
                title={t('VOUCHER.POP_PRODUCT.MESSAGE.CANCEL_BIND_VOUCHER')}
                message={t('VOUCHER.POP_PRODUCT.MESSAGE.CANCEL_BIND_VOUCHER_SUB', { voucherCode: props.dataVoucher?.voucherDetails.find((item: any) => item?.voucherListId === idUnlink)?.voucherCode })}
                type="warning"
                onSubmit={{ onClick: () => handleUnlinkVoucher(idUnlink) }}
                onCancel={{ onClick: () => setIdUnlink(0), title: t('BUTTON.CANCEL') }}
                handleClose={() => setIdUnlink(0)}
            />
            {/* <SnackbarComponent
                onOpen={isOpenSnack}
                onClose={() => setIsOpenSnack(false)}
                label={t('ลบสำเร็จ')}
                type={"success"}
                transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
                autoHideTime={3000}
            /> */}

            <ModalCustom
                title={t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_CODE')}
                textBtnCancel={t('BUTTON.CANCEL')}
                onReset={() => props.onClose(isReload)}
                onClose={() => props.onClose(isReload)}
                alignFooter={'end'}
                closeButton
                size={'lg'}
                component={(
                    <>
                        <Box>
                            <Box display={'flex'} alignItems={'center'} gap={'8px'} >
                                <Box>
                                    {t('VOUCHER.POP_PRODUCT.FORM.NAME')}
                                </Box>
                                <Box>
                                    {props.dataVoucher?.voucherName}
                                </Box>

                                {props.dataVoucher?.detail &&
                                    <span>
                                        <Tooltip title={props.dataVoucher?.detail} placement={'top-start'} sx={{ 'path': { fill: '#A8A8A8' }, }}>
                                            <InfoIcon />
                                        </Tooltip>
                                    </span>
                                }
                            </Box>
                            <Box sx={{ marginTop: '16px' }}>
                                <TableCustom
                                    page={page}
                                    pageLimit={pageLimit}
                                    sortType={sortType}
                                    sortBy={sortBy}
                                    onSort={onRequestSort}
                                    setPageLimit={handleChangeRowsPerPage}
                                    setPage={handleChangePage}
                                    rowCount={rowCount}
                                    headCells={headCells}
                                    rowsData={props.dataVoucher?.voucherDetails?.length ? renderVoucher().map((item: any, index: number) => {
                                        return renderData(item, index)
                                    }) : []}
                                />
                            </Box>
                        </Box>

                    </>
                )}
            />
        </>
    )
}

export default FormViewVoucher